// extracted by mini-css-extract-plugin
export default {"accordion":"Faq_accordion__TSCFZ","question":"Faq_question__i4kkG","answer":"Faq_answer__b00l8"};